const contactRecipients = [
  { name: "Adam Liu", email: "adamliu@princeton.edu" },
  { name: "Brian Seo", email: "brian.seo@princeton.edu" },
  { name: "Dabie Isiofia", email: "di1200@princeton.edu" },
  { name: "Daniel Tu", email: "daniel.tu@princeton.edu" },
  { name: "Joann Amoako", email: "amoakojoann@princeton.edu" },
  { name: "Kaisha Brown", email: "kb9972@princeton.edu" },
  { name: "Michael Njoku", email: "mn2602@princeton.edu" },
  { name: "Nadia Mcbeth", email: "mn1540@princeton.edu" },
  { name: "Rylie Heaton", email: "rh5482@princeton.edu" },
  { name: "Vincent Stone", email: "vincentmstone@princeton.edu" },
];

export default contactRecipients;
